module.exports = __webpack_public_path__ + "img/emls-logo.2ddcc369.svg";